import { getCredVerification } from 'api/credentialing';
import type { AdditionalW9Dto, AdditionalW9Item } from './types';

// additionalW9 的 primary 种子：items 为空时从 Verification 步骤取 taxId / legalTaxName / w9FormUrl
// 种一条 primary（同一 TIN + legal name = 同一份文件，可复用——per eng）。仅首次种一次，之后与
// Verification 各自独立（源头改动不回写、本步换文件也不回写）。拉不到或全空时种空 primary，
// 步骤组件会把它降级为可编辑卡（group provider 未填 Verification 的场景）。
const emptyItem = (it: AdditionalW9Item) => !(it.taxId || '').trim() && !(it.nameOnW9 || '').trim() && !it.fileUrl;

// 「可用的 primary」= 带 primary 标志且至少填了点什么；全空 primary（编辑中物化的兜底卡）
// 不算，种子仍可顶替它补上 Verification 预填
export const hasPrimaryW9 = (dto: AdditionalW9Dto | undefined): boolean =>
    !!dto?.items?.some((it) => it.primary && !emptyItem(it));

// 把种子 primary 合并进当前 dto：已有可用 primary 则原样返回；空 primary 原位顶替；没有则
// 补在最前面。深链注入的非-primary（other）条目一律保留，种子不整体覆盖
export const mergeSeededW9 = (current: AdditionalW9Dto | undefined, seed: AdditionalW9Item): AdditionalW9Dto => {
    if (hasPrimaryW9(current)) return current as AdditionalW9Dto;
    const rest = (current?.items || []).filter((it) => !it.primary);
    return { hasOtherTaxIds: current?.hasOtherTaxIds ?? rest.length > 0, items: [seed, ...rest] };
};

export const seedAdditionalW9 = async (
    current: AdditionalW9Dto | undefined,
    providerId?: number | string,
): Promise<AdditionalW9Item | null> => {
    if (hasPrimaryW9(current)) return null;
    let seed: AdditionalW9Item = { primary: true };
    try {
        const res: any = await getCredVerification(providerId);
        const v = res?.data?.data;
        if (v) {
            seed = {
                taxId: v.taxId || undefined,
                nameOnW9: v.legalTaxName || undefined,
                nameType: 'LEGAL_NAME',
                fileUrl: v.w9FormUrl || undefined,
                primary: true,
            };
        }
    } catch (e) {
        // ignore：拉不到按空 primary 处理
    }
    return seed;
};
